import React from 'react';

export type UserType = 'brands' | 'agencies';

interface UserTypeSelectorProps {
  selectedType: UserType | null;
  onSelectType: (type: UserType) => void;
  disabled?: boolean;
}

const UserTypeSelector: React.FC<UserTypeSelectorProps> = ({ 
  selectedType, 
  onSelectType, 
  disabled = false 
}) => {
  return (
    <div className="w-full mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-3">
        I am a...
      </label>
      <div className="grid grid-cols-2 gap-4">
        {/* Brands Option */}
        <button
          type="button"
          onClick={() => onSelectType('brands')}
          disabled={disabled}
          className={`p-4 rounded-lg border-2 transition-all duration-200 ${
            selectedType === 'brands'
              ? 'border-purple-600 bg-purple-50 text-purple-700'
              : 'border-gray-200 bg-white text-gray-700 hover:border-purple-300 hover:bg-purple-50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="font-semibold text-lg mb-1">Brand Owner</h3>
            <p className="text-sm text-gray-600">
              I want to optimize my own Amazon listings
            </p>
          </div>
        </button>

        {/* Agencies Option */}
        <button
          type="button"
          onClick={() => onSelectType('agencies')}
          disabled={disabled}
          className={`p-4 rounded-lg border-2 transition-all duration-200 ${
            selectedType === 'agencies'
              ? 'border-purple-600 bg-purple-50 text-purple-700'
              : 'border-gray-200 bg-white text-gray-700 hover:border-purple-300 hover:bg-purple-50'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-3">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="font-semibold text-lg mb-1">Agency</h3>
            <p className="text-sm text-gray-600">
              I manage multiple client Amazon accounts
            </p>
          </div>
        </button>
      </div>
    </div>
  );
};

export default UserTypeSelector;
